import { render, staticRenderFns } from "./UPSBarChart.vue?vue&type=template&id=09cfa91a&scoped=true&"
import script from "./UPSBarChart.vue?vue&type=script&lang=js&"
export * from "./UPSBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cfa91a",
  null
  
)

export default component.exports